import { gql } from '@apollo/client/core';

/** The selection lists match the `take` lists in `GuestList.ts`, `GuestListEntry.ts` and `GuestListImport.ts` exactly. */
export const GUEST_LIST_IMPORT_FIELDS = gql`
  fragment GuestListImportFields on EventExport {
    id
    status
    rowCount
    errorCount
    downloadUrl
  }
`;

export const GUEST_LIST_FIELDS = gql`
  fragment GuestListFields on GuestList {
    id
    eventId
    name
    allotment
    claimed
    entries {
      id
      guestListId
      firstName
      lastName
      quantity
      claimed
    }
    importExport {
      ...GuestListImportFields
    }
  }
  ${GUEST_LIST_IMPORT_FIELDS}
`;
